module.exports = __webpack_public_path__ + "img/corporate-business.600f69fb.webp";